import * as Yup from "yup";

const AddLibraryCategoryValidator = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long")
    .max(100, "Name must be less than 100 characters long"),
  description: Yup.string()
    .required("Description is required")
    .min(3, "Description must be at least 3 characters long")
    .max(250, "Description must be less than 250 characters long"),
  status: Yup.string()
    .required("Status is required")
    .oneOf(["1", "2"], "Invalid status"),
  image_name: Yup.string()
    .required("Image name is required")
    .test(
      "is-image",
      "File must be a valid jpg/jpeg,png image file",
      function(value ) {
        if(!value) return true;
        const validExtensions = ['jpg', 'jpeg', 'png'];
        // Check if the file has a valid extension
        const isValid = validExtensions.some(extension => value.toLowerCase().endsWith(extension));
        return isValid;
      }
    ),
});


export default AddLibraryCategoryValidator;